import Button from '@material-ui/core/Button'
import { Auth } from 'aws-amplify'
import React, { useState } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import WebFooter from '../../source/WebScreen/WebFooter'
import InputPassword from './InputPasswordBox'
import './Login.css'
import styles from './LoginForm.module.css'
import PasswordValidations from './PwdValidations'

function ResetPasswordForm(props) {
  const [verificationCode, setVerification] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [disableResetBtn, setdisableResetBtn] = useState(true)
  const [isRevealPassword, setIsRevealPassword] = useState(true)
  const [isRevealConfirmPassword, setIsRevealConfirmPassword] = useState(true)


  const handleConfirmVerification = e => {
    e.preventDefault()
                console.log(password)
    if (password == confirmPassword) {
      props.toggleLoader(true)
      Auth.forgotPasswordSubmit(props.email, verificationCode, password)
        .then(data => {
          props.toggleLoader(false)
          console.log('password reset success')
          console.log(data)
          window.location.reload()
        })
        .catch(err => {
          props.toggleLoader(false)
          console.log(err.message)
          setErrorMessage(err.message)
        })
    } else {
      setErrorMessage('Please enter same password')
    }
  }

  const handleChange = e => {
    if (e.target.name == 'verificationCode') {
      setVerification(e.target.value)
    } else if (e.target.name == 'password') {
      console.log(e.target.name)
      let password = e.target.value
      setPassword(e.target.value)
    } else if (e.target.name == 'confirmPassword') {
      setConfirmPassword(e.target.value)
    }
  }

  const toggleResetBtn = allPassed => {
    setdisableResetBtn(!allPassed)
  }

  const togglePassword = field => {
    if (field === 'password') {
      setIsRevealPassword(!isRevealPassword)
    } else if (field === 'confirmPassword') {
      setIsRevealConfirmPassword(!isRevealConfirmPassword)
    }
  }



  return (
    <div>
      {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
        <div className="loginformnew">
          <div className={styles.loginform_flex_container}>
            {/* Left Panel: Image and Footer */}
            <div className={styles.loginform_left_panel}>
              <div className={styles.loginform_image_wrapper}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
              </div>
              <div className={styles.loginform_footer}>
                Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                Version 6.1.0
              </div>
            </div>
            {/* Right Panel: Form */}
            <div className={styles.loginform_right_panel}>
              <form onSubmit={handleConfirmVerification} className={styles.loginform_form_wrapper}>
                <img src={require('../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                <div className={styles.login_input_container1}>
                  <div className={styles.reset_password_header}>
                    <div className={styles.reset_password_title}>Reset Password</div>
                    <div className={styles.reset_password_subtitle}>
                      We have sent a password reset code by email to {props.destination}. Enter it below to reset your password.
                    </div>
                  </div>

                  {errorMessage.length > 0 && (
                    <div className={styles.login_error_message}>{errorMessage}</div>
                  )}

                  <div style={{ position: 'relative', marginBottom: '15px', width: '100%' }}>
                  <input
                    placeholder="Enter code"
                    className={["login_input_username", styles.loginform_input].join(' ')}
                    type="text"
                    name="verificationCode"
                    required
                    onChange={handleChange}
                    />
                    </div>

                    <div style={{ position: 'relative', marginBottom: '15px', width: '100%' }}>
                      <input 
                        type={isRevealPassword ? "password" : "text"}
                        className={["login_input_username", styles.loginform_input].join(' ')} 
                        name="password"
                        placeholder="Enter new password"
                        value={password}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                      />
                      <span className="p-viewer-web" onClick={() => togglePassword('password')} style={{right:'-5px'}}>
                        {isRevealPassword ? (
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        )}
                      </span>
                    </div>
                    <div style={{ position: 'relative', marginBottom: '15px', width: '100%' }}>
                      <input 
                        type={isRevealConfirmPassword ? "password" : "text"}
                        className={["login_input_username", styles.loginform_input].join(' ')} 
                        name="confirmPassword"
                        placeholder="Enter new password again"
                        value={confirmPassword}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                      />
                      <span className="p-viewer-web" onClick={() => togglePassword('confirmPassword')} style={{right:'-5px'}}>
                        {isRevealConfirmPassword ? (
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        )}
                      </span>
                    </div>
                  <Button type="submit" className={["login_button", styles.loginform_button].join(' ')} onClick={handleConfirmVerification}>
                    CHANGE PASSWORD
                  </Button>

                  <div className={styles.password_validations_wrapper}>
                    <PasswordValidations password={password} allPassed={toggleResetBtn} />
                  </div>
                </div>
                <div className={styles.login_bottom_text}>
                  <div className={styles.login_bottom_subtext}>
                    Go back to{' '}
                    <span className={styles.login_plese_text} onClick={() => props.gotoLoginScreen()}>
                      Sign In
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div class="loginmobile">
          {/* <div class="loginmobile_header"> */}
            {/* <MenuIcon style={{ color: '#ffffff', marginRight: '4vw',width:'8vw' }} /> */}
            {/* <div class="loginmobile_header_text">Member Portal</div> */}
          {/* </div> */}

          <div class="loginmobile_container">
            <form>
            <div className="login_image_container"  style={{paddingTop:'30px'}}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} class="loginmobile_banner" />
            <img src={require('../../source/Images/Banner/logo.png')} className="loginmobile_logo" />
              </div>

              <div class="reset_password_mail_text_msg">
                <div class="forgotmobile_text_details">
                  <div>We have sent a password reset code by email to {props.destination}. Enter it below to reset your password.</div>
                </div>
              </div>

              <div class="loginmobile_input_container">
                {/* <p class="mobile_login_new_error_text" hidden={this.props.errorMsg.length <= 0}>{this.props.errorMsg}</p> */}

                <div class="mobile-linput">
                  <input
                  style={{paddingLeft:'20px'}}
                    placeholder=" Enter code"
                    class="loginmobile_input_username"
                    type="text"
                    name="verificationCode"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div style={{ position: 'relative', marginBottom: '30px' }}>
                  <InputPassword handleChange={handleChange} name={'password'} placeholder="Enter new password" />
                </div>

                <div style={{ position: 'relative', marginBottom: '30px' }}>
                  <InputPassword handleChange={handleChange} name={'confirmPassword'} placeholder="Enter new password again" />
                </div>

                <p className="a-errorMessage" style={{ marginTop: '10px' }} hidden={errorMessage.length <= 0}>
                  {errorMessage}
                </p>
                <Button type="submit" variant="contained" color="" class="loginmobile_button" onClick={handleConfirmVerification}>
                  CHANGE PASSOWRD
                </Button>
              </div>

              <div className="mt-3 passowrd_validation_center">
                <PasswordValidations password={password} allPassed={toggleResetBtn} />
              </div>

              <div class="loginmobile_bottom_text">
                <div class="loginmobile_bottom_subtext2">
                  <div>
                    Go to
                    <span class="loginmobile_please_check" onClick={() => props.gotoLoginScreen()}>
                      {' '}
                      Sign In
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ResetPasswordForm














